var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVoyage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5758",
    "data-name": "Group 5758",
    transform: "translate(-80 -80)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3450",
    "data-name": "Rectangle 3450",
    width: 16,
    height: 16,
    transform: "translate(80 80)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "ferry",
    d: "M4.909,4.636h8.727v2.88L9.273,6.091,4.909,7.516m-1.5,6.575h.044a3.991,3.991,0,0,0,2.909-1.455,3.991,3.991,0,0,0,2.909,1.455,3.991,3.991,0,0,0,2.909-1.455,3.991,3.991,0,0,0,2.909,1.455h.036l1.382-4.865a.786.786,0,0,0-.044-.56.745.745,0,0,0-.436-.364L15.091,8V4.636a1.454,1.454,0,0,0-1.455-1.455H11.455V1H7.091V3.182H4.909A1.455,1.455,0,0,0,3.455,4.636V8L2.516,8.3a.745.745,0,0,0-.436.364.786.786,0,0,0-.044.56m13.055,6.32a5.07,5.07,0,0,1-2.909-.967,5,5,0,0,1-5.818,0,5.07,5.07,0,0,1-2.909.967H2V17H3.455a6.359,6.359,0,0,0,2.909-.727,6.322,6.322,0,0,0,5.818,0A6.337,6.337,0,0,0,15.091,17h1.455V15.545Z",
    transform: "translate(78.727 79)",
    fill: "#000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoyage);
export default __webpack_public_path__ + "static/media/voyage.4d4aad3413085bbd615201df7e413593.svg";
export { ForwardRef as ReactComponent };